<template>
  <transition name="modal-fade">
    <div
      v-if="value"
      class="modal-wrapper"
      tabindex="-1"
      role="dialog"
      @keydown.esc="closeOnEsc"
    >
      <div class="modal-container" @click.self="handleBackdropClick">
        <!-- Backdrop detrás -->
        <div class="modal-backdrop"></div>

        <!-- Modal al frente -->
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <!-- Header -->
            <div class="modal-header">
              <slot name="header"></slot>
              <CButtonClose @click="closeModal"/>
            </div>

            <!-- Body -->
            <div class="modal-body">
              <slot></slot>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
              <slot name="footer">
                <button class="btn btn-secondary" @click="closeModal"><i class="fas fa-times"></i> Cerrar</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CButtonClose from './cButtonClose'

export default {
  name: 'ModalComponent',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
    handleBackdropClick() {
      if (this.closeOnBackdrop) this.closeModal()
    },
    closeOnEsc(event) {
      if (event.key === 'Escape') this.closeModal()
    }
  }
}
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-backdrop {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.modal-dialog {
  position: relative;
  z-index: 1050;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
}

.modal-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-body {
  overflow: auto;
  flex-grow: 1;
}

/* Transición */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fullscreen {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
}
</style>
